import React from 'react';
import RptDailyKPI from './Report_Daily_KPI_Entry';
import '../../../CommonCSS/SocietyCSS.css'

const RptDailyKPIApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Daily KPI Entries</h5>
          </div>
        </div>
        <RptDailyKPI />
      </div>
    </div >
  );
};

export default RptDailyKPIApp;
